import React from 'react';

const LoginRegister = () => (
  <section className="bg-alt">
    <div className="container">
      <div className="row wow slideInUp">
        {/* start login */}
        <div className="col-lg-6 col-12 pb-3">
          <div className="card h-100">
            <div className="card-img-top" />
            <div className="card-body">
              <h1>Login</h1>
              <form>
                <div className="form-group">
                  <label htmlFor="inputEmailForm" className="sr-only form-control-label">
                    Email
                  </label>
                  <div className="mx-auto col-sm-10">
                    <input type="text" className="form-control" id="inputEmailForm" placeholder="email" required />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="inputPasswordForm" className="sr-only form-control-label">
                    Password
                  </label>
                  <div className="mx-auto col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="inputPasswordForm"
                      placeholder="password"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="mx-auto col-sm-10">
                    <div className="checkbox form-control form-control-sm text-center small">
                      <label className="">
                        <input type="checkbox" className="" /> remember me
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="mx-auto col-sm-10 pb-3 pt-2">
                    <button type="submit" disabled className="btn btn-outline-secondary btn-lg btn-block">
                      Sign-in
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* end login */}
        {/* start register */}
        <div className="col-lg-6 col-12 pb-3">
          <div className="card h-100">
            <div className="card-img-top" />
            <div className="card-body">
              <h1>Sign-up</h1>
              <form>
                <div className="form-group">
                  <label htmlFor="input2EmailForm" className="sr-only form-control-label">
                    email
                  </label>
                  <div className="mx-auto col-sm-10">
                    <input type="text" className="form-control" id="input2EmailForm" placeholder="email" required />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="input2PasswordForm" className="sr-only form-control-label">
                    password
                  </label>
                  <div className="mx-auto col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="input2PasswordForm"
                      placeholder="password"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="input2Password2Form" className="sr-only form-control-label">
                    verify
                  </label>
                  <div className="mx-auto col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="input2Password2Form"
                      placeholder="verify password"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="mx-auto col-sm-10 pb-3 pt-2">
                    <button type="submit" disabled className="btn btn-outline-secondary btn-lg btn-block">
                      Register
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* end register */}
      </div>
    </div>
  </section>
);
export default LoginRegister;



// WEBPACK FOOTER //
// ./src/components/LoginRegister.js